// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1fg2t","actions":"GroupTable_actions__lWBVx","deleteModalFooter":"GroupTable_deleteModalFooter__2RAJN"};